<template>
  <!-- Device groups -->
  <TriggerComponentDeviceGroups class="pa-0" :deviceGroupsChosen="deviceGroupsChosen"/>
  <!-- Model Path Matcher -->
  <TriggerComponentModelPathMatcher class="pa-0" :policy="policy" />
  <!-- Match interval -->
  <v-row class="my-0 pt-4 pb-0">
    <v-col cols="3" class="py-1 pr-0">{{ $t("changeMask") }}: </v-col>
    <v-col cols="9" class="py-1 pr-0">
      <div class="radio-container mx-4" @click="togglePolicyChangeMask(TriggerPolicyChangeMaskEnum.VALUE_CHANGED)">
        <v-icon 
          :color="policy.changeMask == TriggerPolicyChangeMaskEnum.VALUE_CHANGED ? 'var(--color-highlight)' : 'var(--color-g4)'"
          class="ecc" 
          style="font-size:22px">{{policy.changeMask == TriggerPolicyChangeMaskEnum.VALUE_CHANGED  ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('valueChanged') }}</div>
      </div>
      <div class="radio-container" @click="togglePolicyChangeMask(TriggerPolicyChangeMaskEnum.TIMESTAMP_CHANGED)">
        <v-icon 
          :color="policy.changeMask == TriggerPolicyChangeMaskEnum.TIMESTAMP_CHANGED ? 'var(--color-highlight)' : 'var(--color-g4)'"
          class="ecc" 
          style="font-size:22px">{{policy.changeMask == TriggerPolicyChangeMaskEnum.TIMESTAMP_CHANGED ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('timestampChanged') }}</div>
      </div>
    </v-col>
  </v-row>
  <!-- skip n changes -->
  <v-row class="my-1">
    <v-col class="py-0">
      <v-text-field
        v-model="policy.skipFirstNChanges"
        type="number"
        :label="$t('setNFirstChangedToSkip')"
        class="pr-2"
        data-qa="prop-control-grid-cols"
        hide-details
      />
    </v-col>
  </v-row>
  <!-- deadband -->
  <v-row class="my-1">
    <v-col cols="7" class="py-0">
      <v-text-field
        v-model="policy.deadband"
        type="number"
        :label="$t('deadband')"
        class="pr-2"
        data-qa="prop-control-grid-cols"
        hide-details
      />
    </v-col>
    <v-col cols="5" class="py-0">
      <v-btn
        :class="{
          'btn-base': true,
          'btn-left': true,
          'btn-active': policy.isPercentage,
          'btn-unactive': !policy.isPercentage,
        }"
        @click="setIsPercentage(true)"
        tile
        variant="plain"
      >
        <span class="col-dk">%</span>
      </v-btn>
      <v-btn
        :class="{
          'btn-base': true,
          'btn-right': true,
          'btn-active': !policy.isPercentage,
          'btn-unactive': policy.isPercentage,
        }"
        @click="setIsPercentage(false)"
        tile
        variant="plain"
      >
      <span class="col-dk">{{ $t("abs") }}</span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import TriggerComponentModelPathMatcher from "./TriggerComponentModelPathMatcher.vue";
import TriggerComponentDeviceGroups from "./TriggerComponentDeviceGroups.vue";
import {
  TriggerPolicyChangeMaskEnum,
  TriggerPolicyOnChange,
} from "./type.util";

export default defineComponent({
  name: "TriggerPolicyAnalogBandComponent",
  components: {
    TriggerComponentModelPathMatcher,
    TriggerComponentDeviceGroups,
  },
  data() {
    return {
      TriggerPolicyChangeMaskEnum: TriggerPolicyChangeMaskEnum,
    };
  },
  props: {
    policy: {
      type: Object as () => TriggerPolicyOnChange,
      default: null,
    },
    deviceGroupsChosen: {
      type: Array,
      default: [],
    },
  },
  methods: {
    setIsPercentage(value: boolean): void {
      this.policy.isPercentage = value;
    },
    togglePolicyChangeMask(mask: TriggerPolicyChangeMaskEnum): void {
      this.policy.changeMask = mask;
    },
  },
});
</script>

<style scoped>
.header {
  font-weight: bold;
}

.radio-container {
  display: inline-flex;
  cursor: pointer;
}
.radio-text{
  margin: auto;
}

.v-theme--light.v-btn.btn-base {
  font-size: 12px;
  font-weight: normal;
  min-height: 42px;
  padding: 0;
  letter-spacing: normal;
}
.v-theme--light.v-btn.btn-active {
  background: var(--color-g2);
}
.v-theme--light.v-btn.btn-unactive {
  background: var(--color-g1);
}
.btn-left {
  border-bottom-left-radius: 5px !important;
  border-top-left-radius: 5px !important;
}
.btn-right {
  border-bottom-right-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
</style>
